import React, { useEffect, useState, useRef,useCallback } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import PropTypes from 'prop-types';
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";
import Swal from 'sweetalert2';
import {
  Box,
  MenuItem,
} from '@mui/material';
import Select from "react-select";

const Employee = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [permission, setPermission] = useState({});
  const [employeetype, setEmployeetype] = useState('all');
  const [supplierName, setSupplierName] = useState([]);
  const [formData, setFormData] = useState({ employeetype: employeetype });

  const genderlist = [
    { value: 'H', label: "H" },
    { value: 'F', label: "F" }
  ];

  useEffect(() => {
    const perm = FindModuleById(251);
    setPermission(perm);

    let empType = 'all';
    if (perm && perm.other_1 == 1 && perm.other_2 == 0) {
      empType = 'fixed';
    }
    if (perm && perm.other_1 == 0 && perm.other_2 == 1) {
      empType = 'seasonal';
    }

    setEmployeetype(empType);

    const updatedFormData = {
      ...formData,
      employeetype: empType,
      season_id: localStorage.getItem("season_id"),
      gender: localStorage.getItem("employee_gender"),
      location: localStorage.getItem("employee_location"),
    };

    setFormData(updatedFormData);

    axios.post("/employees/listing-fixed2", updatedFormData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.employees);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios.post("/employees/listing-saisonal2", updatedFormData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
      .then((response) => {
        if (response.data.code === 200) {
          setDataa(response.data.data.employees);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
 


  useEffect(() => {
    axios.get("/helpers/loading-locations", {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.locations;
          let emp_statusList = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `sts-${index}`,
          }));
          setSupplierName(emp_statusList);
        }
      })
      .catch(console.log);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post("/employees/listing-fixed2", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.employees);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios.post("/employees/listing-saisonal2", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          setDataa(response.data.data.employees);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const editItem = (item) => {
    window.location.href = "/employees-edit/" + item;
  }

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/employees/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success');
              setTimeout(() => {
                window.location.href = "/employees";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  AWS.config.setPromisesDependency();
  AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
  });

  const s3 = new AWS.S3();

  const EmployeeCell = ({ renderedCellValue, row }) => {
    const profilePicture = row?.original?.profile_picture || '';
    const employeeId = row?.original?.id || '';
    let url = '';

    if (profilePicture) {
      const params = { Bucket: AWS_BUCKET, Key: profilePicture };
      url = s3.getSignedUrl('getObject', params);
    }
    return (
      <a href={`/employees-view/${employeeId}`} className="">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <img
            alt="avatar"
            height={70}
            width={70}
            src={url}
            loading="lazy"
            style={{ borderRadius: '100%' }}
          />
          <span>{renderedCellValue}</span>
        </Box>
      </a>
    );
  };

  EmployeeCell.propTypes = {
    renderedCellValue: PropTypes.string.isRequired,
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.number.isRequired,
        profile_picture: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };

  // Columns Definition
  const columns = [
    {
      header: 'Full Name',
      accessorFn: (row) => `${row.first_name} ${row.last_name}`,
      Cell: EmployeeCell,
    },
    { accessorKey: 'gender', header: 'Gender' },
    { accessorKey: 'phone_number', header: 'Phone Number' },
    {
      header: 'Employee Status',
      accessorFn: (row) => row.emp_status?.title || '',
    },
    {
      accessorKey: 'date_of_birth',
      header: 'Date of Birth',
      accessorFn: (row) => {
        if (!row.date_of_birth) return '';
        const date = new Date(row.date_of_birth);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      accessorKey: 'employment_date',
      header: 'Employment Date',
      accessorFn: (row) => {
        if (!row.employment_date) return '';
        const date = new Date(row.employment_date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      accessorKey: 'join_date',
      header: 'Join Date',
      accessorFn: (row) => {
        if (!row.join_date) return '';
        const date = new Date(row.join_date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      header: "Seniority Years",
      accessorFn: (row) => {
        if (!row.join_date) return "0";
        const employmentDate = new Date(row.join_date);
        const today = new Date();
        let years = today.getFullYear() - employmentDate.getFullYear();
        let months = today.getMonth() - employmentDate.getMonth();
        if (today.getDate() < employmentDate.getDate()) {
          months -= 1;
        }
        if (months < 0) {
          years -= 1;
          months += 12;
        }
        if (years < 0) return "0";
        if (years === 0 && months === 0) {
          return "less than a month";
        }
        if (years === 0) {
          return `${months} month${months !== 1 ? "s" : ""}`;
        }
        return `${years} year${years !== 1 ? "s" : ""} ${months} month${months !== 1 ? "s" : ""}`;
      },
    },
    {
      header: 'Family Situation',
      accessorFn: (row) => row.emp_family_status?.title || '',
    },
    {
      header: 'Location',
      accessorFn: (row) => row.emp_location?.title || '',
    },
    { accessorKey: 'shift', header: 'Shift' },
    {
      header: 'Salary Netto',
      accessorFn: (row) => {
        const salary = row.salary_netto ? row.salary_netto.toFixed(2) : '0.00';
        const currencySymbol = row.emp_currency?.symbol || '';
        return `${salary} ${currencySymbol}`;
      },
    },
    {
      header: 'Salary Brutto',
      accessorFn: (row) => {
        const salary = row.salary_brutto ? row.salary_brutto.toFixed(2) : '0.00';
        const currencySymbol = row.emp_currency?.symbol || '';
        return `${salary} ${currencySymbol}`;
      },
    },
    {
      header: 'Total Salary',
      accessorFn: (row) => {
        const salary = row.total_salary ? row.total_salary.toFixed(2) : '0.00';
        const currencySymbol = row.emp_currency?.symbol || '';
        return `${salary} ${currencySymbol}`;
      },
    },
    {
      header: 'CNSS Status',
      accessorFn: (row) => {
        const cnss_status = row.cnss_status && row.cnss_status == 1 ? 'Déclaré(e)' : 'Non - Déclaré(e)';
        return `${cnss_status} `;
      },
    },
    {
      header: 'CNSS Number',
      accessorFn: (row) => {
        const cnss = row.cnss_status && row.cnss_status == 1 ? row.cnss : '';
        return `${cnss} `;
      },
    },
    { accessorKey: 'rib', header: 'RIB' },
    { accessorKey: 'cin', header: 'CIN' },
    { accessorKey: 'matricule', header: 'Matricule' },
    { accessorKey: 'status', header: 'Status' },
    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
    },
  ];

  const handleSelectChangeCustomer = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, location: selectedOption.value });
    localStorage.setItem("employee_location", selectedOption.value);
  };

  const handleSelectChangegender = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, gender: selectedOption.value });
    localStorage.setItem("employee_gender", selectedOption.value);
  };

  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }

  const downloadExcel = (e) => {
    console.log(e);
    const queryString = objectToQueryString(formData);
    window.open(`${base_url}/employees/list-excel-export?${queryString}`, '_blank');
  }

  const resetForm = () => {
    localStorage.removeItem("employee_gender");
    localStorage.removeItem("location");
    setTimeout(() => {
      window.location.href = "/employees";
    }, 500);
  };


   // Refs for all 4 tables
  const topFixedTabScrollRef = useRef(null);
  const tableFixedTabContainerRef = useRef(null);
  const topSeasonalTabScrollRef = useRef(null);
  const tableSeasonalTabContainerRef = useRef(null);
  const topSingleFixedScrollRef = useRef(null);
  const tableSingleFixedContainerRef = useRef(null);
  const topSingleSeasonalScrollRef = useRef(null);
  const tableSingleSeasonalContainerRef = useRef(null);

  // Store cleanup functions
  const fixedTabCleanupRef = useRef(null);
  const seasonalTabCleanupRef = useRef(null);
  const singleFixedCleanupRef = useRef(null);
  const singleSeasonalCleanupRef = useRef(null);
  
  // Generic setup function for any table
  const setupScrollSync = useCallback((tableContainerRef, topScrollRef, cleanupRef, tableName) => {
    // Clean up previous listeners if any
    if (cleanupRef.current) {
      cleanupRef.current();
      cleanupRef.current = null;
    }

    setTimeout(() => {
      const tableContainer = tableContainerRef.current?.querySelector('.MuiTableContainer-root');
      const topScroll = topScrollRef.current;
      const topScrollContent = topScroll?.querySelector('.top-scroll-content');
      
      if (!tableContainer || !topScroll || !topScrollContent) {
        console.log(`${tableName} elements not found`);
        return;
      }
      
      // Sync scrollbar width
      topScrollContent.style.width = `${tableContainer.scrollWidth}px`;
      console.log(`${tableName} scrollbar synced:`, tableContainer.scrollWidth);
      
      const handleTopScroll = () => {
        tableContainer.scrollLeft = topScroll.scrollLeft;
      };
      
      const handleTableScroll = () => {
        topScroll.scrollLeft = tableContainer.scrollLeft;
      };
      
      topScroll.addEventListener('scroll', handleTopScroll);
      tableContainer.addEventListener('scroll', handleTableScroll);
      
      console.log(`${tableName} listeners attached`);
      
      // Store cleanup function
      cleanupRef.current = () => {
        topScroll.removeEventListener('scroll', handleTopScroll);
        tableContainer.removeEventListener('scroll', handleTableScroll);
        console.log(`${tableName} listeners removed`);
      };
    }, 200);
  }, []);

  // Setup functions for each table
  const setupFixedTabScrollSync = useCallback(() => {
    setupScrollSync(tableFixedTabContainerRef, topFixedTabScrollRef, fixedTabCleanupRef, 'Fixed Tab Table');
  }, [setupScrollSync]);

  const setupSeasonalTabScrollSync = useCallback(() => {
    setupScrollSync(tableSeasonalTabContainerRef, topSeasonalTabScrollRef, seasonalTabCleanupRef, 'Seasonal Tab Table');
  }, [setupScrollSync]);

  const setupSingleFixedScrollSync = useCallback(() => {
    setupScrollSync(tableSingleFixedContainerRef, topSingleFixedScrollRef, singleFixedCleanupRef, 'Single Fixed Table');
  }, [setupScrollSync]);

  const setupSingleSeasonalScrollSync = useCallback(() => {
    setupScrollSync(tableSingleSeasonalContainerRef, topSingleSeasonalScrollRef, singleSeasonalCleanupRef, 'Single Seasonal Table');
  }, [setupScrollSync]);

  // Setup initial table based on permissions
  useEffect(() => {
    if (permission.other_1 == 1 && permission.other_2 == 1) {
      // Both tabs - setup seasonal (active by default)
      setupSeasonalTabScrollSync();
    } else if (permission.other_1 == 1 && permission.other_2 == 0) {
      // Fixed only
      setupSingleFixedScrollSync();
    } else if (permission.other_1 == 0 && permission.other_2 == 1) {
      // Seasonal only
      setupSingleSeasonalScrollSync();
    }
  }, [permission, setupSeasonalTabScrollSync, setupSingleFixedScrollSync, setupSingleSeasonalScrollSync]);

  // Re-setup when data changes
  useEffect(() => {
    if (permission.other_1 == 1 && permission.other_2 == 1) {
      // Check which tab is active and setup accordingly
      const fixedTab = document.querySelector('#listing-all');
      const seasonalTab = document.querySelector('#listing-groupby-supplier');
      
      if (fixedTab?.classList.contains('show', 'active')) {
        setupFixedTabScrollSync();
      }
      if (seasonalTab?.classList.contains('show', 'active')) {
        setupSeasonalTabScrollSync();
      }
    } else if (permission.other_1 == 1 && permission.other_2 == 0) {
      setupSingleFixedScrollSync();
    } else if (permission.other_1 == 0 && permission.other_2 == 1) {
      setupSingleSeasonalScrollSync();
    }
  }, [data, dataa, permission, setupFixedTabScrollSync, setupSeasonalTabScrollSync, setupSingleFixedScrollSync, setupSingleSeasonalScrollSync]);

  // Handle tab switching for tabbed view
  useEffect(() => {
    if (!(permission.other_1 == 1 && permission.other_2 == 1)) {
      return; // Only setup tab switching if both tabs are visible
    }

    const handleTabSwitch = (e) => {
      const targetId = e.target.getAttribute('href');
      console.log('Tab switched to:', targetId);
      
      setTimeout(() => {
        if (targetId === '#listing-all') {
          setupFixedTabScrollSync();
        } else if (targetId === '#listing-groupby-supplier') {
          setupSeasonalTabScrollSync();
        }
      }, 300);
    };

    const tabLinks = document.querySelectorAll('[data-bs-toggle="tab"]');
    tabLinks.forEach(link => {
      link.addEventListener('shown.bs.tab', handleTabSwitch);
    });
    
    return () => {
      tabLinks.forEach(link => {
        link.removeEventListener('shown.bs.tab', handleTabSwitch);
      });
    };
  }, [setupFixedTabScrollSync, setupSeasonalTabScrollSync, permission]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (fixedTabCleanupRef.current) fixedTabCleanupRef.current();
      if (seasonalTabCleanupRef.current) seasonalTabCleanupRef.current();
      if (singleFixedCleanupRef.current) singleFixedCleanupRef.current();
      if (singleSeasonalCleanupRef.current) singleSeasonalCleanupRef.current();
    };
  }, []);


  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Employees</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Employees</li>
                </ul>
              </div>
              <div className="col-auto">
                {permission && permission.add == 1 && (
                  <Link to="/employees-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                )}
                &nbsp;&nbsp;
                {permission && permission.list === 1 && (
                  <button className="btn btn-primary" onClick={() => downloadExcel()}>
                    <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Filters */}
          <div id="filter_inputs" className="card filter-card2">
            <div className="card-body p-10">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Location:</label>
                      <Select
                        options={supplierName}
                        name="location"
                        value={supplierName.length > 0 ? supplierName.find(option => option.value == formData.location) : null}
                        onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Select Gender:</label>
                      <Select
                        options={genderlist}
                        name="gender"
                        value={genderlist.find(option => option.value === formData.gender) || null}
                        onChange={(selectedOption) => handleSelectChangegender(selectedOption)}
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        className="btn btn-primary me-1"
                        onClick={resetForm}
                      >
                        <i className="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            {permission && permission.list == 1 && (
              <div className="row" id="listing-followup">
                {/* Both tabs view */}
                {permission && permission.other_1 == 1 && permission.other_2 == 1 && (
                  <div className="col-sm-12">
                    <div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-bottom">
                        <li className="nav-item">
                          <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">
                            Saisonal Employees
                          </a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" href="#listing-all" data-bs-toggle="tab">
                            Fixed Employees
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        {/* Seasonal Employees Tab */}
                        <div className="tab-pane show active" id="listing-groupby-supplier">
                          <div className="row" id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                     <div
                                    ref={topSeasonalTabScrollRef}
                                    className="top-scrollbar"
                                    style={{
                                      overflowX: 'auto',
                                      overflowY: 'hidden',
                                      marginBottom: '10px',
                                      height: '20px'
                                    }}
                                  >
                                    <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                  </div>
                                  <div className="table-responsive production-output-listing2" ref={tableSeasonalTabContainerRef} id="seasonal-table">
                                    <MaterialReactTable
                                      columns={columns}
                                      data={dataa}
                                      enableColumnOrdering
                                      enablePinning
                                      enableRowActions
                                      renderRowActionMenuItems={({ row }) => [
                                        permission?.update == 1 && (
                                          <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                            Edit
                                          </MenuItem>
                                        ),
                                        permission?.delete == 1 && (
                                          <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                            Delete
                                          </MenuItem>
                                        ),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Fixed Employees Tab */}
                        <div className="tab-pane" id="listing-all">
                          <div className="row" id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                 <div
                                    ref={topFixedTabScrollRef}
                                    className="top-scrollbar"
                                    style={{
                                      overflowX: 'auto',
                                      overflowY: 'hidden',
                                      marginBottom: '10px',
                                      height: '20px'
                                    }}
                                  >
                                    <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                  </div>

                                  <div id="fixed-table" className="table-responsive production-output-listing" ref={tableFixedTabContainerRef}>
                                   <MaterialReactTable
                                      columns={columns}
                                      data={data}
                                      enableColumnOrdering
                                      enablePinning
                                      enableRowActions
                                      renderRowActionMenuItems={({ row }) => [
                                        permission?.update == 1 && (
                                          <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                            Edit
                                          </MenuItem>
                                        ),
                                        permission?.delete == 1 && (
                                          <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                            Delete
                                          </MenuItem>
                                        ),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Fixed Only */}
                {permission && permission.other_1 == 1 && permission.other_2 == 0 && (
                  <div className="row" id="listing-followup">
                    <div className="col-sm-12">
                      <div className="card card-table">
                        <div className="card-body">
                         
                            <div
                            ref={topSingleFixedScrollRef}
                            className="top-scrollbar"
                            style={{
                              overflowX: 'auto',
                              overflowY: 'hidden',
                              marginBottom: '10px',
                              height: '20px'
                            }}
                          >
                            <div className="top-scroll-content" style={{ height: '1px' }}></div>
                          </div>

                          <div className="table-responsive" id="single-fixed-table" ref={tableSingleFixedContainerRef}>
                          
                            <MaterialReactTable
                              columns={columns}
                              data={data}
                              enableColumnOrdering
                              enablePinning
                              enableRowActions
                              renderRowActionMenuItems={({ row }) => [
                                permission?.update == 1 && (
                                  <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                    Edit
                                  </MenuItem>
                                ),
                                permission?.delete == 1 && (
                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                    Delete
                                  </MenuItem>
                                ),
                              ]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Seasonal Only */}
                {permission && permission.other_1 == 0 && permission.other_2 == 1 && (
                  <div className="row" id="listing-followup">
                    <div className="col-sm-12">
                      <div className="card card-table">
                        <div className="card-body">
                          <div
                            ref={topSingleSeasonalScrollRef}
                            className="top-scrollbar"
                            style={{
                              overflowX: 'auto',
                              overflowY: 'hidden',
                              marginBottom: '10px',
                              height: '20px'
                            }}
                          >
                            <div className="top-scroll-content" style={{ height: '1px' }}></div>
                          </div>
                          <div className="table-responsive" id="single-seasonal-table"  ref={tableSingleSeasonalContainerRef}>
                            <MaterialReactTable
                              columns={columns}
                              data={dataa}
                              enableColumnOrdering
                              enablePinning
                              enableRowActions
                              renderRowActionMenuItems={({ row }) => [
                                permission?.update == 1 && (
                                  <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                    Edit
                                  </MenuItem>
                                ),
                                permission?.delete == 1 && (
                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                    Delete
                                  </MenuItem>
                                ),
                              ]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employee;